// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"332":"8f4aa783","764":"4f1649a3","911":"4f1649a3","936":"987d1b31"}[chunkId] + ".chunk.css";
};